import { HeaderStyled } from '@components/Common/SharedStyles';
import React from 'react';
import styled from 'styled-components';

const H3Styled = styled.h3`
  ${HeaderStyled};
`;

export const H3: React.FC<any> = props => {
  return <H3Styled {...props}>{props.children}</H3Styled>;
};
